/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Receipt_UnreadableInputs */



/**
* | output |
* | --- |
* | "The figures of this bill could not be read. Please contact oneAI before invoicing it." |
*
* @param {Partner_Receipt_UnreadableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_receipt_unreadable = /** @type {((inputs?: Partner_Receipt_UnreadableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Receipt_UnreadableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Beträge dieser Abrechnung konnten nicht gelesen werden. Bitte wenden Sie sich an oneAI, bevor Sie sie in Rechnung stellen.")
	return /** @type {LocalizedString} */ ("The figures of this bill could not be read. Please contact oneAI before invoicing it.")
});